import React from 'react';
import type { ErrorWrapper } from './errorWrapperTypes';
import { useSelectedMetrics } from '../../logic/useSelectedMetrics';
import { StyledErrorState } from '../StyledErrorState';

export const NoMetricsErrorWrapper: ErrorWrapper = ({ children, blockId }) => {
  const selectedMetrics = useSelectedMetrics();

  if (selectedMetrics.length <= 0) {
    return <StyledErrorState selectedRefId={blockId} header="Please select at least one metric to analyze" />;
  }
  return children;
};
